import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTheme, alpha } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import useScrollTrigger from "@mui/material/useScrollTrigger";

import Container from "components/Container";
import TopNav from "components/TopNav";

import { Topbar, Sidebar, Footer } from "./components";

import pages from "../navigation";

const Main = ({
  children,
  colorInvert = false,
  bgcolor = "transparent",
  style,
}) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up("md"), {
    defaultMatches: true,
  });

  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const open = isMd ? false : openSidebar;

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 38,
  });

  return (
    <Box>
      {/* <Box bgcolor={bgcolor} position={"relative"} zIndex={theme.zIndex.appBar}>
        <Container paddingTop={"8px !important"} paddingBottom={"0 !important"}>
          <TopNav colorInvert={colorInvert} />
        </Container>
      </Box> */}
      <AppBar
        position={"sticky"}
        sx={{
          top: 0,
          zIndex: theme.zIndex.appBar,
          backgroundColor: trigger
            ? theme.palette.background.paper
            : bgcolor === 'transparent'
              ? alpha(theme.palette.background.paper, 0.8)
              : bgcolor,
          backdropFilter: trigger ? 'blur(20px)' : 'none',
          WebkitBackdropFilter: trigger ? 'blur(20px)' : 'none',
          transition: theme.transitions.create(
            ['background-color', 'backdrop-filter', 'box-shadow'],
            {
              duration: theme.transitions.duration.standard,
            }
          ),
          boxShadow: trigger
            ? theme.customShadows.z8
            : 'none',
        }}
        elevation={0}
      >
        <Container
          paddingY={{ xs: 2, md: 2.5 }}
          sx={{
            minHeight: { xs: '64px', md: '72px' },
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Topbar
            onSidebarOpen={handleSidebarOpen}
            pages={pages}
            colorInvert={trigger ? false : colorInvert}
          />
        </Container>
      </AppBar>
      <Sidebar
        onClose={handleSidebarClose}
        open={open}
        variant="temporary"
        pages={pages}
      />
      <main
        style={{
          minHeight: "100vh",
          ...style,
        }}
      >
        {children}
      </main>
      <Container paddingY={4}>
        <Footer />
      </Container>
    </Box>
  );
};

Main.propTypes = {
  children: PropTypes.node,
  colorInvert: PropTypes.bool,
  bgcolor: PropTypes.string,
};

export default Main;
